
import React, { useEffect } from "react";
import Translate from "../components/Translate";
import { useTranslation } from "react-i18next";
import { updateMetaTags } from "../utils/seo";
import PageBanner from "../components/PageBanner";

export default function CopyrightPolicyPage() {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        updateMetaTags(
            `${t('copyright_policy')} | ${t('site-title')}`,
            t('copyright-desc'),
            t('copyright-keywords')
        );
    }, [t, i18n.language]);

    return (
        <section className="w-full min-h-screen bg-primary-50/30 pb-16 text-left">
            <PageBanner
                title={<Translate text={'copyright_policy'} />}
                subtitle={t('policy-copyright-subtitle')}
                badgeText={t('badge-standard')}
            />

            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-12">
                <div className="bg-white rounded-xl shadow-md border border-primary-100 p-8">
                    <h2 className="text-2xl font-bold text-center text-primary-700 mb-6 border-b pb-2">{t('policy-copyright-h1')}</h2>
                    <div className="space-y-8 text-gray-700 leading-relaxed text-left">
                        <section>
                            <p className="text-gray-600">
                                {t('policy-copyright-s1-content')}
                            </p>
                        </section>

                        <section>
                            <p className="text-gray-600">
                                {t('policy-copyright-s2-content')}
                            </p>
                        </section>

                        <section>
                            <p className="text-gray-600">
                                {t('policy-copyright-s3-content')}
                            </p>
                        </section>

                        <section>
                            <p className="text-gray-600">
                                {t('policy-copyright-s4-content')}
                            </p>
                        </section>
                    </div>
                </div>
            </div>
        </section>
    );
}
